$(document).ready(function () {
    if (!window.Fancybox) {
        console.error('Fancybox is required but not loaded');
        return;
    }

    const getUrlParameter = function (sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    // Validation functions
    const isValidYouTubeId = (id) => /^[a-zA-Z0-9_-]{11}$/.test(id);
    const isValidVimeoId = (id) => /^[0-9]+$/.test(id);

    // Check for video parameters
    const youtubeId = getUrlParameter('v') || getUrlParameter('yt');
    const vimeoId = getUrlParameter('vm');

    try {
        if (youtubeId && isValidYouTubeId(youtubeId)) {
            new Fancybox([
                {
                    src: "https://www.youtube.com/watch?v=" + youtubeId,
                    type: "html",
                }
            ], {
                controls: 1,
                enablejsapi: 1,
                rel: 0,
                fs: 1,
                autoplay: 1,
            });
        } else if (vimeoId && isValidVimeoId(vimeoId)) {
            new Fancybox([
                {
                    src: "https://vimeo.com/" + vimeoId,
                    type: "html",
                }
            ], {
                byline: 1,
                color: "00adef",
                controls: 1,
                dnt: 1,
                muted: 0,
            });
        }
    } catch (error) {
        console.error('Error initializing video:', error);
    }

    // Function to construct video URL based on service and ID
    const constructVideoUrl = (videoId, videoService) => {
        let videoUrl = null;

        if (videoService === "youtube") {
            videoUrl = "https://www.youtube.com/watch?v=" + videoId;
        } else if (videoService === "vimeo") {
            videoUrl = "https://vimeo.com/" + videoId;
        }

        return videoUrl;
    };

    // Attach click event to elements with data-fancybox="article-video"
    $(document).on('click', '[data-fancybox="article-video"]', function (e) {
        e.preventDefault();

        const videoId = $(this).data('video-id');
        const videoService = $(this).data('video-service');

        if (videoId && videoService) {
            const videoUrl = constructVideoUrl(videoId, videoService);

            let fancyboxOptions = {
                youtube: {
                    controls: 1,
                    showinfo: 0
                },
                vimeo: {
                    color: "00adef",
                    controls: 1,
                    dnt: 1,
                    muted: 0,
                },
                // Dynamically set type based on video service
                type: function(opts) {
                  if (videoService === "youtube") {
                    return 'youtube';
                  } else if (videoService === "vimeo") {
                    return 'vimeo';
                  } else {
                    return 'iframe';
                  }
                }
            };

            let fancyboxConfig = {};
            if (videoService === "youtube") {
                fancyboxConfig = fancyboxOptions.youtube;
            } else if (videoService === "vimeo") {
                fancyboxConfig = fancyboxOptions.vimeo;
            }

            new Fancybox([
                {
                    src: videoUrl,
                    type: fancyboxOptions.type
                }
            ], fancyboxConfig);
        } else {
            console.error('Invalid video ID or service');
        }
    });
});